import RegistAddr from "../../../components/delivery/address/RegistAddr";

function Regist() {

  return (
    <RegistAddr/>
  );
}

export default Regist;